export default __webpack_public_path__ + "images/icons/icon-check-orange.png";